import './swatch-grid--split';



// WEBPACK FOOTER //
// ./client/src/core/components/swatch-grid/index.js